import {
  API_ENDPOINT,
  useClientApiV3AuthSignupVerifyEmailCreateMutation,
} from '../../resources/@types/accountSchema';

interface UseClientV3AuthSignupVerifyEmailMutation {
  options?: Parameters<typeof useClientApiV3AuthSignupVerifyEmailCreateMutation>[0]['options'];
}

export function useAuthSignupVerifyEmailCreateMutation({
  options,
}: UseClientV3AuthSignupVerifyEmailMutation) {
  return useClientApiV3AuthSignupVerifyEmailCreateMutation({
    url: API_ENDPOINT.CLIENT_V3_AUTH_SIGNUP_VERIFY_EMAIL,
    options,
  });
}
